/**
 * Mobile-facing export for the pure Services domain contract. The source
 * lives outside Edge Function code so Metro can bundle it while the server and
 * client still cannot silently drift into different categories or scope IDs.
 */
export {
  SERVICE_CATALOG,
  SERVICE_CATEGORY_IDS,
  SERVICE_REQUESTER_CANCELLABLE_STATUSES,
  SERVICE_REQUEST_STATUSES,
  SERVICE_OPERATOR_TRANSITIONS,
  SERVICE_TIMINGS,
  SERVICE_WINDOWS,
  isServiceCategory,
  isServiceRequestStatus,
  canOperatorTransitionServiceRequest,
  canRequesterCancelServiceRequest,
  canRequesterAcceptServiceQuote,
  isServiceTiming,
  isServiceWindow,
  serviceCategoryById,
  serviceNeedBelongsToCategory,
  serviceNeedRequiresDestination,
  type ServiceCatalogEntry,
  type ServiceCategoryId,
  type ServiceLocation,
  type ServiceNeed,
  type ServiceRequest,
  type ServiceRequestEvent,
  type ServiceQuote,
  type ServiceRequestInput,
  type ServiceRequestStatus,
  type ServiceTiming,
  type ServiceWindow,
} from '../../shared/services-catalog'
